module.exports = __webpack_public_path__ + "static/media/pc侧边2022.9453b938.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/pc侧边2022.png
// module id = 793
// module chunks = 0